<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="status-icon">
    <icon-colored-draft v-if="status === packageStatuses.Draft" />
    <icon-colored-retired v-if="status === packageStatuses.Retired" />
    <icon-colored-published v-if="status === packageStatuses.Published" />
  </div>
</template>

<script type="text/babel">
  import { IconColoredDraft, IconColoredPublished, IconColoredRetired } from '@/common/icons/colored';
  import { PackageStatus } from '@/common/models';

  export default {
    components: {
      IconColoredDraft,
      IconColoredPublished,
      IconColoredRetired,
    },
    props: {
      status: {
        type: String,
        default: PackageStatus.Draft,
      },
    },
    data() {
      return {
        packageStatuses: PackageStatus,
      };
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  div {
    display: inline-block;
    width: 2.4rem;
    height: 2.4rem;
  }
</style>
